import React from "react";
import { CommunityFeedType, CommunityProps, FeedLikeType } from "../../types";
import {
  DiscussMenu,
  DiscussContent,
  Activity,
  DiscussModal,
  DiscussOption,
  DiscussImage,
  DiscussVideo,
  DiscussVideoImage,
} from "..";
import useBodyScrollLock from "../../utils/useBodyScrollLock";
import { useQuery } from "@apollo/client";
import { GET_FEED_LIKES } from "../../apollo/operations";
import { setLikedPost } from "../../redux/slices/communityFeedSlice";
import { useDispatch } from "react-redux";

type DiscussListProps = {
  communityFeed: CommunityFeedType | undefined;
  refetch: () => void;
  community: CommunityProps | undefined;
  index: any;
  isRefetching: () => void;
  loadData: boolean;
  Type?: string
};

const DiscussList: React.FC<Partial<DiscussListProps>> = ({
  communityFeed,
  refetch,
  community,
  index,
  isRefetching,
  loadData,
  Type,
}) => {
  const textareaRef = React.useRef<HTMLTextAreaElement | null>(null);
  const inputArea = React.useRef<HTMLInputElement | null>(null);
  const [openModal, setOpenModal] = React.useState(false);
  const [isLocked, toggle] = useBodyScrollLock();
  const [editContent, setEditContent] = React.useState(false);
  const [showAllImages, setShowAllImages] = React.useState<number | null>(null);

  const [feedLikes, setFeedLikes] = React.useState<FeedLikeType | undefined>(
    {} as any
  );
  const [loadings, setLoadings] = React.useState(false);
  const [modalRemove, setModalRemove] = React.useState(false);

  // useMemo(() => {
  //   // Initialize the feedLikeStatus with false for each feed ID
  //   const initialStatus =
  //     communityFeeds &&
  //     communityFeeds?.reduce((acc, feed) => {
  //       acc[feed.id] = false;
  //       return acc;
  //     }, {} as { [key: string]: boolean });

  //   setFeedLikeStatus(initialStatus);
  //   setFeedLikeRemove(initialStatus);
  // }, [communityFeeds]);

  const dispatch = useDispatch();

  const { refetch: refetchLikes, loading } = useQuery(GET_FEED_LIKES, {
    variables: {
      where: {
        communityFeed: {
          id: communityFeed?.id,
        },
      },
    },
    notifyOnNetworkStatusChange: true,
    onCompleted: (data) => {
      // console.log(data);
      dispatch(setLikedPost(data));
      setFeedLikes(data);
      if (!loading) {
        setLoadings(false);
      }
    },
  });

  // const user = useSelector((state: any) => state.user.userDetails);

  // const handleCopyImage = () => {
  //   const imgElement = document.getElementById("imga") as HTMLImageElement; // Cast to HTMLImageElement

  //   if (imgElement) {
  //     const imageUrl = imgElement.src;

  //     const link = document.createElement("a");
  //     link.href = imageUrl;
  //     link.download = "image";
  //     link.click();
  //     showToast("Image downloaded succesfully", "success");
  //   } else {
  //     showToast("Failed to download image", "error");
  //   }
  // };

  // const downloadImage = ({ imageUrl, fileName }: any) => {
  //   const downloadLink = document.createElement('a');
  //   downloadLink.href = imageUrl;
  //   downloadLink.download = `ecobook${fileName}`;
  //   document.body.appendChild(downloadLink);
  //   downloadLink.click();
  //   document.body.removeChild(downloadLink);
  // };

  //This is a mutation for updating the post.
  // The refetch is passed as a prop.

  const handleOnOpen = () => {
    if (typeof toggle === "function") {
      toggle();
    }
    setOpenModal(true);
  };

  const handleOnClose = () => {
    if (typeof toggle === "function") {
      toggle();
    }
    setOpenModal(false);
  };

  React.useState(() => {
    if (typeof toggle === "function" && isLocked === true ) {
      toggle();
      if(openModal){
        handleOnClose()
      }
    }
  });
  // The feedImages is used to contain the mediaUrl
  const Vid_Img = communityFeed?.mediaUrl || [];

  return (
    <div
      className="rounded lg:shadow bg-white flex flex-col items-center mb-3 lg:mb-0 py-4 relative"
      key={index * 2}
    >
      <div className="w-full mx-auto justify-between h-10 px-4 flex mb-3 relative">
        <DiscussMenu communityFeed={communityFeed} community={community} type={Type}/>
        <DiscussOption
          communityFeed={communityFeed}
          setEditContent={setEditContent}
          refetch={refetch}
          toggle={toggle}
          // handleCopyImage={handleCopyImage}
        />
      </div>
      {Vid_Img?.map((img_vid, index) => (
        <DiscussContent
          content={communityFeed?.content}
          editContent={editContent}
          setEditContent={setEditContent}
          communityFeed={communityFeed}
          feedImage={img_vid.imageUrl}
          feedVideo={img_vid.videoUrl}
          key={index * 52}
          toggle={toggle}
          isLocked={isLocked}
          refetch={refetch}
        />
      ))}
      {Vid_Img?.map((a, index) =>
        a.imageUrl &&
        a.videoUrl &&
        a.imageUrl.length > 0 &&
        a.videoUrl.length > 0 ? (
          <DiscussVideoImage
            selectedVideos={a.videoUrl}
            key={index + 47}
            imageUpload={a.imageUrl}
            setShowAllImages={setShowAllImages}
            showAllImages={showAllImages}
            toggle={toggle}
            isLocked={isLocked}
          />
        ) : a.imageUrl && a.imageUrl.length > 0 ? (
          <DiscussImage
            key={index * 44}
            setShowAllImages={setShowAllImages}
            showAllImages={showAllImages}
            feedImages={a.imageUrl}
          />
        ) : (
          a.videoUrl &&
          a.videoUrl.length > 0 && (
            <DiscussVideo
              videos={a.videoUrl}
              key={index * 88}
              setShowAllVideos={setShowAllImages}
              showAllVideos={showAllImages}
            />
          )
        )
      )}

      <Activity
        communityFeed={communityFeed}
        textArea={textareaRef}
        openModal={openModal}
        onOpen={handleOnOpen}
        inputArea={inputArea}
        key={index + 25}
        feedLikes={feedLikes}
        loading={loading}
        refetch={refetchLikes}
        setLoadings={setLoadings}
        setModalRemove={setModalRemove}
        refetchAllFeeds={refetch}
      />

      <div className=" overflow-auto h-full px-4" key={communityFeed?.id}>
        {Vid_Img?.map((image) => (
          <DiscussModal
            openModal={openModal}
            onClose={handleOnClose}
            communityFeed={communityFeed}
            textArea={textareaRef}
            refetch={refetch}
            isLocked={isLocked}
            inputArea={inputArea}
            feedImages={image.imageUrl}
            feedVideo={image.videoUrl}
            isRefetching={isRefetching}
            key={communityFeed?.id}
            loadData={loadData}
            feedLikes={feedLikes}
            loading={loading}
            refetchLikes={refetchLikes}
            loadings={loadings}
            setLoadings={setLoadings}
            setModalRemove={setModalRemove}
            modalRemove={modalRemove}
          />
        ))}
      </div>
    </div>
  );
};

export default DiscussList;
